/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailingTaskGrid/Actions/PipelineOutcomeFailingTaskGridActions" />
import { PipelineReportBaseActions } from "Pipeline/Analytics/Common/Actions/PipelineReportBaseActions";
import { ITaskData } from "../Types";

export class PipelineOutcomeFailingTaskGridActions extends PipelineReportBaseActions<ITaskData[]> {}
